import { Input, InputNumber, Radio, Select, Space, Typography } from 'antd';
import type { FieldMeta } from '../../../api/types';
import type { TextBlockSection } from '../../../contract/types';

interface Props {
  section: TextBlockSection;
  onChange: (s: TextBlockSection) => void;
  fieldMetas: FieldMeta[];
}

export function TextBlockEditor({ section, onChange, fieldMetas }: Props) {
  const insertField = (fieldName: string) => {
    onChange({ ...section, content: section.content + `{{${fieldName}}}` });
  };

  return (
    <div>
      <Input.TextArea
        value={section.content}
        onChange={(e) => onChange({ ...section, content: e.target.value })}
        placeholder={"输入文本内容，支持多行\n使用 {{字段名}} 插入字段值\n金额大写：{{总金额|大写}} → 人民币中文大写"}
        autoSize={{ minRows: 3, maxRows: 10 }}
        style={{ marginBottom: 8 }}
      />
      <Space size={12} wrap align="start">
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>插入字段</Typography.Text>
          <br />
          <Select
            size="small"
            style={{ width: 160 }}
            placeholder="选择字段"
            showSearch
            optionFilterProp="label"
            value={undefined}
            onChange={(v) => { if (v) insertField(v); }}
            options={fieldMetas.map((m) => ({ label: m.name, value: m.name }))}
          />
        </div>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>对齐</Typography.Text>
          <br />
          <Radio.Group
            size="small"
            value={section.align ?? 'left'}
            onChange={(e) => onChange({ ...section, align: e.target.value })}
            optionType="button"
            options={[
              { label: '左', value: 'left' },
              { label: '中', value: 'center' },
              { label: '右', value: 'right' },
            ]}
          />
        </div>
        <div>
          <Typography.Text type="secondary" style={{ fontSize: 11 }}>字号(px)</Typography.Text>
          <br />
          <InputNumber
            size="small"
            min={8}
            max={36}
            value={section.fontSizePx}
            onChange={(v) => onChange({ ...section, fontSizePx: v })}
            placeholder="默认"
            style={{ width: 72 }}
          />
        </div>
      </Space>
    </div>
  );
}
